// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as DialogForm from "../../components/DialogForm/DialogForm.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function get(state, field) {
  if (field === "PersonName") {
    return state.personName;
  } else {
    return state.placeName;
  }
}

function set(state, field, value) {
  if (field === "PersonName") {
    return {
      personName: value,
      placeName: state.placeName
    };
  } else {
    return {
      personName: state.personName,
      placeName: value
    };
  }
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function PlaceAdd(props) {
  let onSubmit = props.onSubmit;
  let form = Form.use({
    personName: props.initialPersonName,
    placeName: ""
  }, Validators$1.schema([
    Validators$1.required("PlaceName"),
    Validators$1.required("PersonName")
  ]), param => {
    let raiseSubmitFailed = param.raiseSubmitFailed;
    Stdlib_Promise.$$catch(onSubmit(param.state.values), error => {
      let errorMessage;
      if (error.RE_EXN_ID === "JsExn") {
        let msg = Stdlib_JsExn.message(error._1);
        errorMessage = msg !== undefined ? `Chyba: ` + msg : "Neznámá chyba";
      } else {
        errorMessage = "Neznámá chyba";
      }
      raiseSubmitFailed(errorMessage);
      return Promise.resolve();
    });
  }, undefined, undefined, "OnDemand", undefined);
  return <DialogForm.make
    formId={"add_place"}
    heading={"Nové místo"}
    onDismiss={props.onDismiss}
    visible={true}
  >
    <Form.Provider.make
      value={form}
    >
      <form
        id={"add_place"}
        autoComplete={"off"}
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={`reset ` + Styles.fieldset.grid}
        >
          <Form.Field.make
            field={"PlaceName"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"placeName"}
              inputSlot={<input
                type={"text"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={"Název místa"}
            />}
          />
          <Form.Field.make
            field={"PersonName"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"personName"}
              inputSlot={<input
                type={"text"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={"Moje přezdívka"}
            />}
          />
        </fieldset>
      </form>
    </Form.Provider.make>
  </DialogForm.make>;
}

let make = PlaceAdd;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* Form Not a pure module */
